import {
  GetAuditStatsCommandInput,
  GetAuditStatsCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { auditService } from 'src/data/api/helios-service-ts/audit/auditService';
import { auditStatsKeys } from 'src/data/api/helios-service-ts/audit/queries/keys';

export const useAuditStatsQuery = <TData = GetAuditStatsCommandOutput>(
  input: GetAuditStatsCommandInput,
  options?: Omit<
    UseQueryOptions<GetAuditStatsCommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: auditStatsKeys.getStats(input),
    queryFn: () => auditService.getStats(input),
  });
};
